/**
 * 接口数据预加载
 */
import { RULE_TYPE_MAP } from '../config';

// 通过组件列表获取需要预处理的cgi，这里进行了归档去重
function getPreloadList(options, preloadList) {
  let newPreloadList = preloadList;
  options.forEach((item) => {
    const componentInfo = RULE_TYPE_MAP[item.componentName];
    if (componentInfo && componentInfo.cgi) {
      newPreloadList.length += 1;
      // 这里对使用了同一个cgi调用的组件进行了归档
      if (newPreloadList[componentInfo.cgi]) {
        newPreloadList[componentInfo.cgi].push(item.componentName);
      } else {
        newPreloadList[componentInfo.cgi] = [item.componentName];
      }
    } else if (Object.prototype.hasOwnProperty.call(item, 'children')) {
      newPreloadList = getPreloadList(item.children, newPreloadList);
    }
  });
  return newPreloadList;
}

export default function (context, config) {
  const { ruleOptions } = config;
  const preloadList = getPreloadList(ruleOptions, { length: 0 });
  const listQueue = [];
  // 判断处理的队列是否全部完成
  const checkFinish = (cb) => {
    if (listQueue.length === preloadList.length) {
      cb();
    }
  };
  return new Promise((resolve) => {
    const xhr = function (cgi) {
      context.$ajax
        .get(cgi)
        .then((res) => {
          // 对成功的接口进行标记
          preloadList[cgi].forEach((name) => {
            listQueue.push({
              name,
              status: 'success',
              response: res,
            });
          });
          checkFinish(() => {
            resolve(listQueue);
          });
        })
        .catch((err) => {
          // 对失败的接口进行标记
          preloadList[cgi].forEach((name) => {
            listQueue.push({
              name,
              status: 'error',
              error: err,
            });
          });
          checkFinish(() => {
            resolve(listQueue);
          });
        });
    };
    for (const cgi in preloadList) {
      if (Object.prototype.hasOwnProperty.call(preloadList, cgi) && cgi !== 'length') {
        xhr(cgi);
      }
    }
  });
}
